import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-echarts-header" }
const _hoisted_2 = { class: "home-echarts-header__title" }

import { ref, watch, inject } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import type { Ref, PropType } from 'vue'

const __default__ = { name: 'LeadConversion' }

interface ItemType {
  clueType: number
  clueTypeStr: string
  num: number
}
interface ValueProps {
  transVos: ItemType[]
  [key: string]: any
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String as PropType<string>,
    required: true
  },
  value: {
    type: Object as PropType<ValueProps>,
    required: true
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '437px'
  },
  spinning: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  }
},
  setup(__props) {

enum Subdomain {
  Fbu = 'fbu',
  Lbu = 'lbu'
}
const subdomain = inject<Subdomain>('subdomain') || Subdomain.Fbu

const props = __props

const fbuEnum = [
  { value: 100, name: '全部线索', itemStyle: { color: '#3F97FF' } },
  { value: 86, name: '有效线索', itemStyle: { color: '#66ACFF' } },
  { value: 71, name: '投放线索', itemStyle: { color: '#8CC1FF' } },
  { value: 55, name: '潜在客户', itemStyle: { color: '#B2D6FF' } },
  { value: 38, name: '签约客户', itemStyle: { color: '#B2D6FF' } },
  { value: 0, name: '成交客户', itemStyle: { color: '#D9EAFF' } }
]
const lbuEnum = [
  { value: 100, name: '全部线索', itemStyle: { color: '#3F97FF' } },
  { value: 80, name: '有效线索', itemStyle: { color: '#66ACFF' } },
  { value: 60, name: '投放线索', itemStyle: { color: '#8CC1FF' } },
  { value: 40, name: '潜在客户', itemStyle: { color: '#B2D6FF' } },
  { value: 0, name: '成交客户', itemStyle: { color: '#D9EAFF' } }
]
const funnelEnum = {
  [Subdomain.Fbu]: fbuEnum,
  [Subdomain.Lbu]: lbuEnum
}

const showECharts = ref(false)
const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>)
const initChart = (data: ItemType[]) => {
  const labelLine = data.map((item) => ({
    value: 0,
    name: item.clueTypeStr,
    itemStyle: { color: '#999' }
  }))
  const funnelList = data.map((item, index) => ({
    value: funnelEnum[subdomain][index].value,
    name: item.clueTypeStr,
    itemStyle: funnelEnum[subdomain][index].itemStyle
  }))
  setOptions({
    tooltip: {
      trigger: 'item',
      formatter: '{b} : {c}'
    },
    series: [
      {
        type: 'funnel',
        left: 455,
        top: 30,
        bottom: 60,
        width: 0,
        min: 0,
        max: 0,
        minSize: 0,
        maxSize: 0,
        sort: 'none',
        z: 1,
        gap: 2,
        label: {
          show: true,
          position: 'left',
          formatter: (params) => {
            return params.name
          }
        },
        labelLine: {
          length: 300,
          lineStyle: {
            width: 1,
            type: 'dashed',
            color: '#ccc'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: () => ''
        },
        data: labelLine
      },
      {
        type: 'funnel',
        left: 150,
        top: 30,
        bottom: 60,
        width: '70%',
        min: 20,
        max: 100,
        minSize: '10%',
        maxSize: '100%',
        sort: 'none',
        gap: 2,
        label: { show: false },
        emphasis: {
          label: { show: false }
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            const { name } = params
            const item = data.find((item) => item.clueTypeStr === name)
            return `${name} : ${item?.num}` || ''
          }
        },
        data: funnelList
      }
    ]
  })
}

watch(
  () => props.value,
  (newValue) => {
    if (newValue && newValue.transVos && newValue.transVos.length > 0) {
      showECharts.value = true
      setTimeout(() => initChart(newValue.transVos))
    } else {
      showECharts.value = false
      setTimeout(() => initChart([]))
    }
  },
  {
    deep: true,
    immediate: true
  }
)

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home-echarts-wrap",
    style: _normalizeStyle({ width: __props.width, height: __props.height })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1)
    ]),
    _createVNode(_component_a_spin, {
      spinning: __props.spinning,
      delay: 200
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "home-echarts-content"
        }, null, 512), [
          [_vShow, showECharts.value]
        ]),
        (!showECharts.value)
          ? (_openBlock(), _createBlock(_component_dc_layout_empty, {
              key: 0,
              type: "nothing"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["spinning"])
  ], 4))
}
}

})